// extracted by mini-css-extract-plugin
export default {"labelStyle":"label_labelStyle__5NBoG"};